
import React from 'react';

const Logo = ({ width = 120, height = 30 }) => (
    <img 
        src="/logo.svg" 
        alt="EventPlan Logo" 
        width={width} 
        className="d-inline-block"
    />
);

export default Logo;
